
import Vue from 'vue';
import { Data as HeadlinesData, DataWithHref, QueryResult } from '@root/modules/headlines/types/headlines';
import UniversalHeadlinesService from '@root/modules/headlines/services/UniversalHeadlines.service';
import getHeadlineWithHref from '@root/modules/headlines/utils/getHeadlineWithHref';
import HeadlineBlocks from '@root/common/components/base/headline/HeadlineBlocks.vue';
import ArticlesCounter from '@root/views/article/components/multimedija/ArticlesCounter.vue';
import ArticleHandler from '@root/views/article/components/multimedija/ArticleHandler.vue';

interface Methods {
  getHeadline: (headline: HeadlinesData) => DataWithHref;
  getTopHeadlines: () => void;
  handleScroll: () => void;
}
interface Data {
  cssVariables: Record<string, any>;
  root: any;
  data: Record<string, any>;
  domain: string;
  headlines: HeadlinesData[];
  pager: QueryResult['pager'];
  limit: number;
  settings: Record<string, any>;
  scrollImageTop: number;
}

interface Computed {
  categoryAdditionalData: Record<string, any>;
  cssVars: object;
}

export default Vue.extend<Data, Methods, Computed, unknown>({
  components: {
    HeadlineBlocks,
    ArticlesCounter,
    ArticleHandler,
  },
  data() {
    const { domain } = this.$channelConfig('settings');
    return {
      root: null,
      cssVariables: {},
      data: {
        items: [],
      },
      domain,
      headlines: [],
      pager: {
        count: 0,
        limit: 0,
        offset: 0,
      },
      limit: 12,
      settings: {
        channel: false,
        category: false,
        lead: false,
        publishDate: false,
        author: false,
        titleComment: true,
        slidesPerBreakpoint: [1.5, 2, 3],
      },
      scrollImageTop: 0,
    };
  },
  computed: {
    cssVars() {
      return {};
    },
    categoryAdditionalData() {
      let categoryAdditionalData = {};

      if (this.$route && this.$route.params.category) {
        const categorySlug = this.$route.params.subcategory || this.$route.params.category;
        const customCategorySettings = this.$channelConfig('page').category?.component?.header;
        if (customCategorySettings && Array.isArray(customCategorySettings)) {
          const categoryAdditionalSettings = customCategorySettings.find((item: { categories: string | string[] }) => item.categories.includes(categorySlug));
          categoryAdditionalData = categoryAdditionalSettings?.additionalData || {};
        }
      }
      return categoryAdditionalData;
    },
  },
  watch: {
    cssVariables: {
      handler: function () {
        this.$nextTick(() => {
          if (Object.keys(this.cssVariables).length !== 0) {
            Object.keys(this.cssVariables).forEach((key) => {
              if (this.root) {
                this.root.style.setProperty(key, this?.cssVariables[key]);
              }
            });
          }
        });
      },
      immediate: true,
    },
  },
  created() {
    if (this.categoryAdditionalData.cssVariables) {
      this.cssVariables = this.categoryAdditionalData.cssVariables;
    }
  },
  mounted() {
    if (process.client) {
      this.root = document.documentElement;
      window.addEventListener('scroll', this.handleScroll);

      this.$nextTick(() => {
        if (typeof this.categoryAdditionalData.id !== 'undefined') {
          this.getTopHeadlines();
        }
      });
    }
  },
  methods: {
    getHeadline(headline) {
      const fakeDomainEnabled = this.$config.FAKE_DOMAIN_ENABLED;
      return getHeadlineWithHref({ headline, domain: this.domain, fakeDomainEnabled });
    },
    async getTopHeadlines() {
      const universalHeadlinesService = new UniversalHeadlinesService();
      const headlinesData = await universalHeadlinesService.fetch({
        domain: this.domain,
        categoryId: this.categoryAdditionalData.id,
        limit: this.limit,
        getCount: true,
      });

      const headlines = headlinesData.items;
      const pager = headlinesData.pager;

      if (headlines.length) {
        this.headlines = headlines.map((headline) => this.getHeadline(headline)) || [];
        this.pager = pager;
      }
    },
    handleScroll() {
      if (process.client) {
        const windowHeight = window.innerHeight;
        const windowScrollTop = window.scrollY;
        let x = null;
        x = 2000 - windowScrollTop;
        const imageOfset = (windowHeight - x) / 10;
        this.scrollImageTop = imageOfset;
      }
    },
  },
});
